import * as fs from "node:fs";
import * as path from "node:path";
import * as os from "node:os";
import { fileURLToPath } from "node:url";

function expandUser(p: string): string {
  if (p.startsWith("~")) return path.join(os.homedir(), p.slice(1));
  return p;
}

function parseEnvFile(p: string): void {
  const content = fs.readFileSync(p, "utf-8");
  for (const rawLine of content.split(/\r?\n/)) {
    let line = rawLine.trim();
    if (!line || line.startsWith("#")) continue;
    if (line.startsWith("export ")) line = line.slice(7).trim();
    const eq = line.indexOf("=");
    if (eq < 0) continue;
    const key = line.slice(0, eq).trim();
    let value = line.slice(eq + 1).trim();
    if (
      value.length >= 2 &&
      value[0] === value[value.length - 1] &&
      (value[0] === "'" || value[0] === '"')
    ) {
      value = value.slice(1, -1);
    }
    if (key && value && !process.env[key]) {
      process.env[key] = value;
    }
  }
}

export function candidateEnvPaths(): string[] {
  const paths: string[] = [];
  const explicit = (process.env.SCRIPTCTL_ENV_FILE ?? "").trim();
  if (explicit) paths.push(expandUser(explicit));
  const skillDir = (process.env.SCRIPTCTL_SKILL_DIR ?? "").trim();
  if (skillDir) paths.push(path.join(expandUser(skillDir), ".env"));
  let here: string;
  try {
    here = fileURLToPath(import.meta.url);
  } catch {
    here = process.cwd();
  }
  let cursor = path.resolve(here);
  const seen = new Set<string>();
  while (true) {
    const parent = path.dirname(cursor);
    if (parent === cursor || seen.has(parent)) break;
    seen.add(parent);
    paths.push(path.join(parent, ".env"));
    cursor = parent;
  }
  return paths;
}

export function loadLocalEnv(): void {
  const skip = process.env.SCRIPTCTL_NO_DOTENV;
  if (skip === "1" || skip === "true" || skip === "True") return;
  const visited = new Set<string>();
  for (const envPath of candidateEnvPaths()) {
    let resolved: string;
    try {
      resolved = fs.existsSync(envPath) ? fs.realpathSync(envPath) : envPath;
    } catch {
      resolved = envPath;
    }
    if (visited.has(resolved)) continue;
    if (!fs.existsSync(envPath) || !fs.statSync(envPath).isFile()) continue;
    visited.add(resolved);
    parseEnvFile(envPath);
  }
}
